// Endocrine subsection form field enum
export enum EndocrineFormField {
  ENDOCRINE_WNL = 'medical-background/endocrine/endocrine-wnl',
  ENDOCRINE_MENSTRUAL_CYCLE = 'medical-background/endocrine/menstrual-cycle',
  ENDOCRINE_MENSTRUAL_DATE = 'medical-background/endocrine/menstrual-date',
  ENDOCRINE_NOTES = 'medical-background/endocrine/endocrine-notes',
  ENDOCRINE_SYSTEM_SUMMARY = 'medical-background/endocrine/system-summary'
}
